import { useEffect, useState } from "react";
import Svg from "../components/figs/Svg";

export function useContentModal() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    content: <></>,
    isBlank: false,
  });

  const setTitle = (value) => {
    setModalState((prev) => ({ ...prev, title: value }));
  };

  const setContent = (content) => {
    setModalState((prev) => ({ ...prev, content }));
  };

  const setIsBlank = (value) => {
    setModalState((prev) => ({ ...prev, isBlank: value }));
  };

  const handleOpen = () => {
    setModalState((prev) => ({ ...prev, isOpen: true }));
  };

  const handleClose = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  const ContentModal = (
    <ContentModalPopup
      titleName={modalState.title}
      content={modalState.content}
      isOpen={modalState.isOpen}
      isBlank={modalState.isBlank}
      onClose={handleClose}
    />
  );

  return {
    setContent,
    setTitle,
    handleOpen,
    handleClose,
    ContentModal,
    setIsBlank,
  };
}

function ContentModalPopup({ titleName, content, isOpen, onClose, isBlank }) {
  const [visible, setVisible] = useState(false);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setRendered(true);
      setTimeout(() => setVisible(true), 50);
    } else {
      setVisible(false);
      setTimeout(() => setRendered(false), 300);
    }
  }, [isOpen]);

  if (!rendered) return null;

  if (isBlank) return content;

  return (
    <div className="general_popup_container">
      <div
        className={`general_popup unset_max_width transition-all duration-300 ${
          visible ? "open" : "close"
        }`}
      >
        <div className="general_popup_title">
          <span>{titleName}</span>
          <span onClick={onClose} className="cursor-pointer">
            <Svg iconName="close" />
          </span>
        </div>
        <div>{content}</div>
      </div>
    </div>
  );
}
